import {Component, Input} from '@angular/core';
import {Booking} from '../../shared/model/booking.entity';
import {Administrator, BookingOfficer, Interpreter, IndividualClient, OrganisationalRepresentative} from '../../shared/model/user.entity';
import {GLOBAL} from '../../shared/global';
import {BOOKING_STATE} from '../../shared/model/booking-state.enum';
import * as moment from 'moment';
import { BookingInterpreter } from '../../shared/model/contact.entity';
@Component({
    selector: 'app-booking-info',
    templateUrl: './booking-info.component.html',
    styleUrls: ['./booking-info.component.css']
})
export class BookingInfoComponent {

    @Input() selectedBookingModel: Booking = new Booking();

    constructor() { }

    get showGenderPreference() {
      return this.isCurrentUserAdminOrBookingOfficer() && this.selectedBookingModel.gender_preference !== 'no_preference';
    }

    isBookingInProgress(): boolean {
        return Boolean(this.selectedBookingModel.state === BOOKING_STATE.In_progress);
    }

    isCurrentUserAdminOrBookingOfficer(): boolean {
        return Boolean(GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer);
    }

    isInterpreter(): boolean {
        return GLOBAL.currentUser instanceof Interpreter;
    }

    isClientOrInterpreter(): boolean {
        return Boolean(GLOBAL.currentUser instanceof Interpreter || GLOBAL.currentUser instanceof IndividualClient);
    };

    isOrgRep(): boolean {
        return Boolean(GLOBAL.currentUser instanceof OrganisationalRepresentative);
    }

    isClientOrOrgRep(): boolean {
        return Boolean(GLOBAL.currentUser instanceof IndividualClient || GLOBAL.currentUser instanceof OrganisationalRepresentative);
    }

    isClientInterpAndBookInProgress(): boolean {
        return this.isClientOrInterpreter() && this.isBookingInProgress();
    }

    isClientAndBookingInProgress(): boolean {
        return Boolean(GLOBAL.currentUser instanceof IndividualClient && this.isBookingInProgress());
    }
    isInterpreterStatusAccepted(booking: Booking) {
        if (Boolean(GLOBAL.currentUser instanceof Interpreter)) {
            let r = [];
            r = booking.interpreters.filter(i => i.id === GLOBAL.currentUser.id && i.state === 'Accepted');
            return r.length;
        }
        return false;
    }
    isFieldHasValue(field: any) {
        return (field !== '' && field !== null && field !== undefined);
    }
    calculateDaysAgo(created_at, start_time) {
        return GLOBAL.calculateDaysAgo(created_at, start_time);
    }
    getQueryableRole(role: string) {
      return this.selectedBookingModel[role].toUpperCase().replace(/\s/g, '');
  }

  stringifyUser(id: string) {
      return btoa( this.selectedBookingModel[id]);
  }

  findAndReplaceWithLink(text: string) {
    const urlRegex = /\b(https?|www\.)\S+\b/ig;
    return text ? text.replace(urlRegex, (url) => `<a href="${url.startsWith('www') ? `//${url}` : url}" target="_blank">${url}</a>`) : text;
  }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-info/booking-info.component.ts